
export default {
  name: 'ProductInfoGalleryShopSimilarItems',
  props: {
    webId: {
      type: String,
      default: '',
    },
    getSimilarSrc: {
      type: String,
      default: null,
    },
    isFromMainImage: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      isSyteAiDiscoveryVisible: false,
    };
  },
  computed: {
    similarIconImg() {
      if (this.isFromMainImage) {
        return 'IconShopSimilarPdp-white-32x32';
      }
      return this.$store.state.metaData?.addons?.head?.isBoutique ? 'IconShopSimilarPdpBoutique-32x32' : 'IconShopSimilarPdp-32x32';
    },
    isBoutiquePage() {
      return this.$store.state.metaData?.addons?.head?.isBoutique || false;
    },
  },
  methods: {
    initSyteAi() {
      if (!this.$syteai) {
        return;
      }
      const syteAppReadyHandler = () => {
        this.$refs.sytebtn?.click();
        this.$nextTick(() => {
          const syteContainer = document.querySelector('#imajs-overlay--');
          if (this.isBoutiquePage) {
            syteContainer?.classList.add('is_boutique');
          }
        });
        this.subscribeSyteAiEvents();
      };
      this.$syteai.init();
      if (window.SyteApp?.isReady) {
        syteAppReadyHandler();
      } else {
        window.addEventListener('syteapp_is_ready', syteAppReadyHandler, { once: true });
      }
    },
    subscribeSyteAiEvents() {
      window.SyteApp.subscribeEvent('modalClosed', () => {
        this.isSyteAiDiscoveryVisible = false;
        this.observerDiscovery.disconnect();
      });
      window.SyteApp.subscribeEvent('discoveryButtonClick', () => {
        this.initObserverDiscovery();
        this.observerDiscovery.observe(document.body, { childList: true, subtree: true });
      });
    },
    initObserverDiscovery() {
      // check is syteAi discovery popup rendered
      this.observerDiscovery = new MutationObserver(() => {
        const dialogElement = document.querySelector('.syte-desktop-layout-container-discovery_button');
        if (dialogElement) {
          setTimeout(() => {
            this.isSyteAiDiscoveryVisible = true;
            dialogElement.removeAttribute('tabindex');
          }, 50);
        }
      });
    },
  },
};
